export default "__VITE_ASSET__e4f54c9d__$_?nuxt_component=async__"